
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutii-finantare/credit-consum-traditional",
      function () {
        return require("private-next-pages/solutii-finantare/credit-consum-traditional.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutii-finantare/credit-consum-traditional"])
      });
    }
  